import { Input } from '../../ui/input';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../ui/select';
import { Search } from 'lucide-react';
import { PAYMENT_METHOD_FILTER_OPTIONS } from './payment_method_helpers';
import { useFeatures } from '../../../context/FeatureContext';

/**
 * Search + type/status/payment-method filters for the invoice table.
 */
export default function InvoiceFilters({
  searchQuery, onSearchChange,
  typeFilter, onTypeFilterChange,
  statusFilter, onStatusFilterChange,
  methodFilter, onMethodFilterChange,
}) {
  const { isPlanFeatureEnabled } = useFeatures();
  // iter335c — only show invoice types the tenant's plan includes.
  const can = (k) => !isPlanFeatureEnabled || isPlanFeatureEnabled(k);
  return (
    <div className="flex flex-wrap gap-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input
          placeholder="Search parent, player..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 w-64"
          data-testid="invoice-search-input"
        />
      </div>
      <Select value={typeFilter} onValueChange={onTypeFilterChange}>
        <SelectTrigger className="w-40" data-testid="invoice-type-filter">
          <SelectValue placeholder="Type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" data-testid="invoice-type-option-all">All Types</SelectItem>
          {can('bookings.small_groups') && <SelectItem value="small_group" data-testid="invoice-type-option-small-group">Small Group</SelectItem>}
          {can('enrollments.core') && <SelectItem value="enrollment" data-testid="invoice-type-option-enrollment">Enrollment</SelectItem>}
          {can('tournaments.registrations') && <SelectItem value="tournament" data-testid="invoice-type-option-tournament">Tournament</SelectItem>}
          {can('bookings.lanes') && <SelectItem value="lane_booking" data-testid="invoice-type-option-lane-booking">Lane Booking</SelectItem>}
          {can('commerce.uniforms') && <SelectItem value="uniform" data-testid="invoice-type-option-uniform">Uniform</SelectItem>}
          <SelectItem value="manual" data-testid="invoice-type-option-manual">Manual</SelectItem>
        </SelectContent>
      </Select>
      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="w-32" data-testid="invoice-status-filter">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All</SelectItem>
          <SelectItem value="overdue">Overdue (all unpaid)</SelectItem>
          <SelectItem value="processing">Processing (ACH)</SelectItem>
          <SelectItem value="paid">Paid</SelectItem>
          <SelectItem value="void">Void</SelectItem>
          <SelectItem value="refunded">Refunded</SelectItem>
        </SelectContent>
      </Select>
      <Select value={methodFilter || 'all'} onValueChange={onMethodFilterChange}>
        <SelectTrigger className="w-48" data-testid="invoice-method-filter">
          <SelectValue placeholder="Method" />
        </SelectTrigger>
        <SelectContent>
          {PAYMENT_METHOD_FILTER_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
